import { Backdrop, CircularProgress, Container, Grid } from '@material-ui/core'
import {
    Add as AddIcon, ArrowBack, Save as SaveIcon 
} from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import SelectSupplier from '../../../components/Form/SelectSupplier'
import TextField from '../../../components/Form/TextField'
import ButtonUI from '../../../components/ui/ButtonUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import MvcApi from '../../../services/MvcApi'
import permissions from '../../../utils/Permissions'
import { useStyles } from '../Style'
import MvcStatus from '../../../interfaces/MvcStatus'
import * as Yup from 'yup'
import { useSnackbar } from 'notistack'
import { Autocomplete } from '@mui/material'
import { DriverInfo } from '../../../interfaces/Mvm'
import DateField from '../../../components/Form/Date'
import SelectCNHType from '../../../components/Form/SelectCNHType'
import SelectVehicleType from '../../../components/Form/SelectVehicleType'
import MvcInvoiceList from '../components/MvcInvoiceList'
import { Mvc } from '../../../interfaces/Mvc'
import { isAfter, isEqual } from 'date-fns'
import Success from '../../../components/Form/Success'
import MvcInvoiceItemsList from '../components/MvcInvoiceItemsList'
import MvcLogList from '../components/MvcLogList'

const opcoes = [
    { url: 'printMvc', descricao: 'Imprimir MVC', state: {}},
    { url: '/Mvc', descricao: 'Pesquisar', state: {}}
]

const SubmitMvc: React.FC = () => {
    const classes = useStyles()
    const [circularLoading, setCircularLoading] = useState(true)
    const { user, hasPermission } = useAuth()
    const { t: tGeneral } = useTranslation("General")
    const { t: tValidation } = useTranslation("Validation")
    const { t: tMvc } = useTranslation("Mvc")
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar()
    const [mvc, setMvc] = useState<Mvc | null>(null)
    const [driverName, setDriverName] = useState<string>("")
    const [driverLoading, setDriverLoading] = useState<boolean>(false)
    const [drivers, setDrivers] = useState<DriverInfo[]>([])
    const isInsert = !mvc
    const isView = window.location.pathname.toLowerCase().includes('/view') || window.location.pathname.toLowerCase().includes('/viewpa')
    const isViewPA = window.location.pathname.toLowerCase().includes('/viewpa')
    const isViewDraft = isView && mvc?.status === MvcStatus.STATUS_DRAFT 
    const isEdit = mvc !== null && !isView
    const isEditDraft = isEdit && mvc.status === MvcStatus.STATUS_DRAFT 
    const [title, setTitle] = useState<string>("")
    const [success, setSuccess] = useState(false)
    const [mvcNumber, setMvcNumber] = useState<any>(null)
    const [mvcId, setMvcId] = useState<any>(null)

    useEffect(() => {

        if (mvc && mvc.companyId != Number(user.company.companyID))
            history.replace('/mvc');

        if (!hasPermission(permissions.MVC.Search))
            history.replace('NoPermission');
    }, [history, user])

    useEffect(() => {
        var title = ''
        if (!mvc)
            title = `${tGeneral("submit")} Mvc`
        else if (isViewDraft)
            title = `${tGeneral("view")} Mvc: ${tGeneral("draft")}`
        else if (isView)
            title = `${tGeneral("view")} Mvc: ${mvc.mvcNumber}`
        else if (isInsert || isEditDraft)
            title = `${tGeneral("edit")} Mvc: ${tGeneral("draft")}`
        else if (isEdit)
            title = `${tGeneral("edit")} Mvc: ${mvc.mvcNumber}`

        setTitle(title);

        var mvcId = Number(window.location.pathname.toLowerCase()
        .replace('/submitmvc/', '')
        .replace('/viewpa', '')
        .replace('/view', ''));

        if (isViewPA) {
            saveAccountingPendingUserResolution(mvcId);
        }        
    }, [mvc])

    //Campos do Form
    interface IFormPanel {
        supplier: any;
        originArea: any;
        destinationArea: any;
        shippingCompanySupplier: any;
        supplierView: any;
        originAreaView: any;
        destinationAreaView: any;
        shippingCompanySupplierView: any;
        driverName: any;
        driverRGNumber: any;
        driverCPFNumber: any;
        driverCNHType: any;
        driverCNHTypeView: any;
        driverCNHNumber: any;
        driverCNHExpirationDate:  any;
        vehicleType: any;
        vehicleTypeView: any;
        vehicleBrandDescription: string;
        vehiclePlateNumber: string;
        cartPlateNumber: string;
        helperQuantity: number;
        cTeNumber: string;
        observation: string;

        invoices: any;
        invoices_Sales: any;
        invoices_Rack: any;
        invoices_Others: any;

        invoiceItems: any;
        invoiceItems_Sales: any;
        invoiceItems_Rack: any;
        invoiceItems_Others: any;
        mvcLogs: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setValue, clearErrors, setError } = useForm<IFormPanel>({
        defaultValues: {
            supplier: {},
            originArea: {},
            destinationArea: {},
            shippingCompanySupplier: {},
            supplierView: '',
            originAreaView: '',
            destinationAreaView: '',
            shippingCompanySupplierView: '',
            driverName: '',
            driverRGNumber: '',
            driverCPFNumber: '',
            driverCNHType: {},
            driverCNHTypeView: '',
            driverCNHNumber: '',
            driverCNHExpirationDate: null,
            vehicleType: {},
            vehicleTypeView: '',
            vehicleBrandDescription: '',
            vehiclePlateNumber: '',
            cartPlateNumber: '',
            helperQuantity: 0,
            cTeNumber: '',
            observation: '',

            invoices: [],
            invoices_Sales: [],
            invoices_Rack:  [],
            invoices_Others:  [],

            invoiceItems: [],
            invoiceItems_Sales: [],
            invoiceItems_Rack:  [],
            invoiceItems_Others:  [],
            mvcLogs: []
        }
    });

    useEffect(() => {
        setCircularLoading(true)

        var mvcId = Number(window.location.pathname.toLowerCase()
            .replace('/submitmvc/', '')
            .replace('/viewpa', '')
            .replace('/view', ''))

        if (isNaN(mvcId) || mvcId === 0) {
            setCircularLoading(false)
            return
        }

        MvcApi.getMvc(mvcId)
            .then(response => {
                if (response) {
                    setMvc(response)
                    setMvcId(response.id)
                    setMvcNumber(response.mvcNumber)

                    if (response.supplierId) {
                        setValue('supplier', { 
                            code: response.supplierId, 
                            label: response.supplierId + ' - ' + response.supplierCorporateName, 
                            name: response.supplierCorporateName, 
                            sapCode: response.supplierSapCode,
                            cnpj: response.supplierCnpj })
                        setValue('supplierView', response.supplierId + ' - ' + response.supplierCorporateName)
                    }

                    if (response.originSupplierId) {
                        setValue('originArea', { 
                            code: response.originSupplierId.toString(), 
                            label: response.originSupplierId.toString() + ' - ' + response.originSupplierCorporateName, 
                            name: response.originSupplierCorporateName, 
                            sapCode: response.originSupplierSapCode,
                            cnpj: response.originSupplierCnpj })
                        setValue('originAreaView', response.originSupplierId.toString() + ' - ' + response.originSupplierCorporateName)
                    }

                    if (response.destinationSupplierId) {
                        setValue('destinationArea', { 
                            code: response.destinationSupplierId.toString(), 
                            label: response.destinationSupplierId.toString() + ' - ' + response.destinationSupplierCorporateName, 
                            name: response.destinationSupplierCorporateName, 
                            sapCode: response.destinationSupplierSapCode,
                            cnpj:  response.destinationSupplierCnpj})
                        setValue('destinationAreaView', response.destinationSupplierId.toString() + ' - ' + response.destinationSupplierCorporateName)
                    }

                    if (response.shippingCompanySupplierId) {
                        setValue('shippingCompanySupplier', { 
                            code: response.shippingCompanySupplierId.toString(), 
                            label: response.shippingCompanySupplierId.toString() + ' - ' + response.shippingCompanySupplierCorporateName, 
                            name: response.shippingCompanySupplierCorporateName, 
                            sapCode: response.shippingCompanySupplierSapCode,
                            scacCode: response.shippingCompanySupplierScacCode,
                            cnpj: response.shippingCompanySupplierCnpj })
                        setValue('shippingCompanySupplierView',response.shippingCompanySupplierId.toString() + ' - ' + response.shippingCompanySupplierCorporateName)
                    }

                    setValue('driverName', response.driverName)
                    setDriverName(response.driverName)
                    setValue('driverRGNumber', response.driverRGNumber)
                    setValue('driverCPFNumber', response.driverCPFNumber)
                    
                    if (response.driverCNHType) {
                        setValue('driverCNHType', { 
                            code: response.driverCNHType, 
                            label: response.driverCNHType })
                        setValue('driverCNHTypeView', response.driverCNHType)
                    }

                    setValue('driverCNHNumber', response.driverCNHNumber)
                    setValue('driverCNHExpirationDate', response.driverCNHExpirationDate)

                    if (response.vehicleType) {
                        setValue('vehicleType', { 
                            code: response.vehicleType, 
                            label: response.vehicleTypeDescription })
                        setValue('vehicleTypeView', response.vehicleTypeDescription)
                    }

                    setValue('vehicleBrandDescription', response.vehicleBrandDescription)
                    setValue('vehiclePlateNumber', response.vehiclePlateNumber)
                    setValue('cartPlateNumber', response.cartPlateNumber)
                    setValue('helperQuantity', response.helperQuantity)
                    setValue('cTeNumber', response.cTeNumber)
                    setValue('observation', response.observation)
                    
                    setValue('invoices', response.invoices)
                    setValue('invoiceItems', response.invoices)
                    setValue('invoices_Sales', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType === 'V'))
                    setValue('invoices_Rack', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType === 'E'))
                    setValue('invoices_Others', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType !== 'V' && x.invoiceType !== 'E' ))
                    setValue('invoiceItems_Sales', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType === 'V'))
                    setValue('invoiceItems_Rack', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType === 'E'))
                    setValue('invoiceItems_Others', response.invoices.filter((x:{invoiceType: string}) => x.invoiceType !== 'V' && x.invoiceType !== 'E' ))
                
                    setValue('mvcLogs', response.logs)
                } else {
                    enqueueSnackbar(tGeneral("objectNotFound"), { variant: 'warning' })
                    history.push(isViewPA ? '/PendingAccounting' :'/Mvc')
                }
            })
            .finally(() => setCircularLoading(false))
    }, [])

    const onSubmit = async (data: any) => { }

    const formValidation = async (data: any, isSubmit: boolean) => {
        var result = false

        clearErrors()
        try {   

            let schema = Yup.object()

            if (isSubmit)
                schema = Yup.object().shape({

                    supplier: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),
                    
                    originArea: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),
                    
                    destinationArea: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),
                    
                    shippingCompanySupplier: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),

                    driverName: Yup.string().required(tValidation("requiredField")),

                    driverRGNumber: Yup.string().required(tValidation("requiredField")),

                    driverCPFNumber: Yup.string().required(tValidation("requiredField")),

                    driverCNHType: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),

                    driverCNHNumber: Yup.string().required(tValidation("requiredField")),
                    
                    driverCNHExpirationDate: Yup.string().nullable().test("driverCNHExpirationDate", "A data de vencimento não pode ser inferior ao dia atual", (value) => {
                        var dateRef = new Date(value as 'string')
                        var dateNow = (new Date()).setHours(0,0,0,0)

                        return isEqual(dateRef, dateNow) || isAfter(dateRef, dateNow);
                    }),

                    vehicleType: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),

                    vehicleBrandDescription: Yup.string().required(tValidation("requiredField")),

                    vehiclePlateNumber: Yup.string().required(tValidation("requiredField")),
                })
            else
                schema = Yup.object().shape({

                    originArea: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),

                    destinationArea: Yup.object().nullable().required(tValidation("requiredField"))
                        .shape({code: Yup.string().required(tValidation("requiredField"))}),

                })


            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length == 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                        "supplier" | 
                        "originArea" | 
                        "destinationArea" | 
                        "shippingCompanySupplier" | 
                        "driverName" | 
                        "driverRGNumber" | 
                        "driverCPFNumber" | 
                        "driverCNHType" | 
                        "driverCNHNumber" | 
                        "driverCNHExpirationDate" | 
                        "vehicleType" | 
                        "vehicleBrandDescription" | 
                        "vehiclePlateNumber" | 
                        "cartPlateNumber" | 
                        "helperQuantity" | 
                        "cTeNumber" | 
                        "observation" | 
                        "invoices_Sales" | 
                        "invoices_Rack" | 
                        "invoices_Others", 
                    { message: error.message });
                })

                errors.forEach(element => { 
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(element, { variant: 'warning' }) 
                })
            }

            result = false;
        }

        return result
    }

    const loadModelOutForm = (formData: IFormPanel) => {
        
        let mvcTemp: Mvc = {
            id: mvc?.id,
            cartPlateNumber: formData.cartPlateNumber,
            companyId: Number(user.company.companyID),
            cTeNumber: formData.cTeNumber,
            driverCNHExpirationDate: formData.driverCNHExpirationDate,
            driverCNHNumber: formData.driverCNHNumber,
            driverCNHType: formData.driverCNHType?.code,
            driverCPFNumber: formData.driverCPFNumber,
            driverName: formData.driverName,
            driverRGNumber: formData.driverRGNumber,
            vehicleType: formData.vehicleType?.code,
            vehicleTypeDescription: formData.vehicleType?.label,
            observation: formData.observation,
            plantId: Number(user.company.plantID),
            vehiclePlateNumber: formData.vehiclePlateNumber,
            vehicleBrandDescription: formData.vehicleBrandDescription,

            supplierCnpj: formData.supplier?.cnpj,
            supplierCorporateName: formData.supplier?.name,
            supplierId: formData.supplier?.code,
            supplierSapCode: formData.supplier?.sapCode,

            shippingCompanySupplierCnpj: formData.shippingCompanySupplier?.cnpj,
            shippingCompanySupplierCorporateName: formData.shippingCompanySupplier?.name,
            shippingCompanySupplierId: formData.shippingCompanySupplier?.code,
            shippingCompanySupplierSapCode: formData.shippingCompanySupplier?.sapCode,
            shippingCompanySupplierScacCode: formData.shippingCompanySupplier?.scacCode,

            originSupplierCorporateName: formData.originArea?.name,
            originSupplierId: formData.originArea?.code,
            originSupplierSapCode: formData.originArea?.sapCode,
            originSupplierCnpj: formData.originArea?.cnpj,

            destinationSupplierCnpj: formData.destinationArea?.cnpj,
            destinationSupplierCorporateName: formData.destinationArea?.name,
            destinationSupplierId: formData.destinationArea?.code,
            destinationSupplierSapCode: formData.destinationArea?.sapCode,

            helperQuantity: formData.helperQuantity,

            invoices: isInsert || isEditDraft ? formData.invoices : formData.invoiceItems,
        }
        return mvcTemp
    }

    const save = async (submit: boolean) => {
        let data = getValues()

        var validForm = await formValidation(data, submit)
        
        if (validForm == false) {
            return
        }

        var model = loadModelOutForm(data)
        model.submitAfterInsert = submit
        
        setCircularLoading(true)

        if (isInsert) {
            MvcApi.postMvc(model)
                .then((result: any) => {
                    enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' });
                    setMvcNumber(result.data?.mvcNumber)
                    setMvcId(result.data?.id)
                    if (submit)
                        setSuccess(true)
                    else
                        history.replace('/Mvc')
                })
                .finally(() => { 
                    setCircularLoading(false)
                })
        }
        else if (isEdit) {
            MvcApi.putMvc(model)
            .then((result: any) => {
                enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' })
                setMvcNumber(result.data?.mvcNumber)
                setMvcId(result.data?.id)
                if (submit)
                        setSuccess(true)
                    else
                        history.replace('/Mvc')
            })
            .finally(() => { setCircularLoading(false) })
        }
    }

    const handleDriverChange = (value: any) => {
        if (!value) return

        let driver = drivers.find((x: any) => x.driverName === value);

        if (!driver) return

        setValue('driverName', driver.driverName)
        setValue('driverRGNumber', driver.driverRGNumber)
        setValue('driverCPFNumber', driver.driverCPFNumber)
        setValue('driverCNHType', { code: driver.driverCNHType, label: driver.driverCNHType }) 
        setValue('driverCNHNumber', driver.driverCNHNumber)
        setValue('driverCNHExpirationDate', driver.driverCNHExpirationDate)
    }

    const handleSearchDriver = async(shippingCompanySupplierId : any) => {
        if (shippingCompanySupplierId === 0) return

        setDriverLoading(true);
        
        let items: any[] = [];

        await MvcApi.getDriverData(shippingCompanySupplierId, +user.company.companyID, 5)
        .then(result => {
            items = result ? result.map((driver: DriverInfo) => {
                return { 
                    label: driver.driverName,
                    driverName: driver.driverName || "",
                    driverRGNumber: driver.driverRGNumber || "",
                    driverCPFNumber: driver.driverCPFNumber || "",
                    driverCNHType: driver.driverCNHType || "",
                    driverCNHNumber: driver.driverCNHNumber || "",
                    driverCNHExpirationDate: driver.driverCNHExpirationDate || "",
                };
            }) : [];
            setDrivers(items)
            setDriverLoading(false)
        }).finally(() => setDriverLoading(false));;
    }

    const handleShippingSupplierChange = (shippingSupplier: any) => {
        if(!shippingSupplier) {
            setDrivers([])  
            return;
        }
        
        handleSearchDriver(shippingSupplier.code)
    }

    const saveAccountingPendingUserResolution = async (mvcId: number) => {
        MvcApi.saveAccountingPendingUserResolution(mvcId);
    }

    if (success)
            return (
                <Container maxWidth={false} component="main">
                    <div className={classes.rootContent}>
                        <div className={classes.paper}>
                            <Success opcoes={opcoes} recordType="MVC" MvmNumber={mvcNumber} MvcId={mvcId}/>
                        </div>
                    </div>
                </Container>
            )
    else
        return (
            <Container maxWidth={false} component="main">

                <PageTitle title={title} />
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <form translate={undefined} onSubmit={undefined} style={{  width: "98%"}} >

                            <Grid container spacing={1}>
                                {isView ?
                                    <>
                                        <Grid item xs={3}>
                                            <TextField 
                                                label={tMvc("supplierCode")} 
                                                name="supplierView" 
                                                control={control} 
                                                fullWidth
                                                InputLabelProps={{shrink:true}}
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}/> 
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField 
                                                label={tMvc("shippingCompanySupplier")} 
                                                name="shippingCompanySupplierView" 
                                                control={control} 
                                                fullWidth
                                                InputLabelProps={{shrink:true}}
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}/> 
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField 
                                                label={tMvc("originArea")} 
                                                name="originAreaView" 
                                                control={control} 
                                                fullWidth
                                                InputLabelProps={{shrink:true}}
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}/> 
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField 
                                                label={tMvc("destinationArea")} 
                                                name="destinationAreaView" 
                                                control={control} 
                                                fullWidth
                                                InputLabelProps={{shrink:true}}
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}/> 
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <Grid item xs={3}>
                                            <SelectSupplier 
                                                label={tMvc("supplierCode")}
                                                name={"supplier"}
                                                control={control}
                                                style={{width: '100%'}} 
                                                setValue={setValue}
                                                multiple={false}
                                                loadUserSupplier={(mvc === null)} />

                                        </Grid>
                                        <Grid item xs={3}>
                                            <SelectSupplier 
                                                label={tMvc("shippingCompanySupplier")}
                                                name={"shippingCompanySupplier"}
                                                control={control}
                                                onChange={handleShippingSupplierChange}
                                                style={{width: '100%'}} 
                                                setValue={setValue}
                                                multiple={false}
                                                loadUserSupplier={(mvc === null)}
                                                serviceType={'T'} /> 
                                        </Grid>
                                        <Grid item xs={3}>
                                            <SelectSupplier 
                                                label={tMvc("originArea")}
                                                name={"originArea"}
                                                control={control} 
                                                style={{width: '100%'}}
                                                setValue={setValue}
                                                loadUserSupplier={(mvc === null)}
                                                multiple={false} />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <SelectSupplier 
                                                label={tMvc("destinationArea")}
                                                name={"destinationArea"}
                                                control={control} 
                                                style={{width: '100%'}}
                                                setValue={setValue}
                                                loadUserSupplier={(mvc === null)}
                                                multiple={false}
                                                CDLC={true} />
                                        </Grid>
                                    </>
                                }
                            </Grid>

                                        {/* se estiver visualizando e não tiver permissão esconder os campos */}
                        {(!mvc?.id || mvc.status === MvcStatus.STATUS_DRAFT || hasPermission('VIS_SEGURANCA_PATRIMONIAL')) && (
                            <Grid container spacing={1} >
                                <Grid item xs={2}>
                                    <Autocomplete
                                        freeSolo
                                        value={driverName}
                                        disableClearable
                                        disabled={driverLoading || isView}
                                        defaultValue={driverName}
                                        options={drivers.map((option) => option.driverName)}
                                        onInputChange={(e: any, value: any) => handleDriverChange(value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params} 
                                                fullWidth
                                                control={control}
                                                name="driverName"
                                                label={tMvc("driverName")}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    type: 'search',
                                                    readOnly: driverLoading ||  isView,
                                                    classes: {
                                                        input: isView ? classes.inputBlocked : classes.rootTextBox
                                                    },
                                                    endAdornment: (
                                                        <React.Fragment>
                                                        {driverLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                                />
                                            )}
                                        />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("driverRGNumber")} 
                                        name="driverRGNumber" 
                                        control={control} 
                                        type="number"
                                        fullWidth
                                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 20) }}
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: isView ? true : false,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("driverCPFNumber")} 
                                        name="driverCPFNumber" 
                                        control={control} 
                                        type="number"
                                        fullWidth
                                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 11) }}
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>
                                <Grid item xs={2}>
                                    {!isView ? 
                                        <SelectCNHType 
                                            label={tMvc('driverCNHType')} 
                                            name={'driverCNHType'}
                                            control={control} />
                                    :    
                                        <TextField 
                                            label={tMvc("driverCNHType")} 
                                            name="driverCNHTypeView" 
                                            control={control} 
                                            fullWidth
                                            InputLabelProps={{shrink:true}}
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked
                                                }}}/> 
                                    }
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("driverCNHNumber")} 
                                        name="driverCNHNumber" 
                                        control={control} 
                                        type="number"
                                        fullWidth
                                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 11) }}
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>

                                <Grid item xs={2}>
                                    <DateField label={tMvc("driverCNHExpirationDate")} name="driverCNHExpirationDate" control={control} fullWidth
                                        allowPast={false}
                                        InputLabelProps={{shrink:true}}
                                        disable={!isView ? false : true}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                            <Grid container spacing={1}  >
                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("vehiclePlate")} 
                                        name="vehiclePlateNumber" 
                                        control={control}
                                        mask="aaa9*99" 
                                        fullWidth
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("cartPlate")} 
                                        name="cartPlateNumber" 
                                        control={control} 
                                        mask="aaa9*99"
                                        fullWidth
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>

                                <Grid item xs={2}>
                                    {!isView ? 
                                        <SelectVehicleType 
                                            label={tMvc('vehicleType')} 
                                            name={'vehicleType'}
                                            control={control}/>
                                    :
                                        <TextField 
                                            label={tMvc("vehicleType")} 
                                            name="vehicleTypeView" 
                                            control={control} 
                                            fullWidth
                                            InputLabelProps={{shrink:true}}
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked
                                                }}}/> 
                                    }
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("vehicleBrandDescription")} 
                                        name="vehicleBrandDescription" 
                                        control={control} 
                                        fullWidth
                                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 30) }}
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>
                            
                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("helperQuantity")} 
                                        name="helperQuantity" 
                                        control={control} 
                                        type="number"
                                        fullWidth
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField 
                                        label={tMvc("cTeNumber")} 
                                        name="cTeNumber" 
                                        control={control} 
                                        type="number"
                                        fullWidth
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <TextField
                                        label={tMvc("observation")}
                                        name="observation"
                                        control={control} 
                                        variant={'outlined'}
                                        multiline={true}
                                        fullWidth
                                        InputLabelProps={{shrink:true}}
                                        InputProps={{
                                            readOnly: !isView ? false : true ,
                                            classes: {
                                                input: !isView ? classes.rootTextBox : classes.inputBlocked
                                            }
                                        }}/> 
                                </Grid>
                            </Grid>
                            {(isInsert || isEditDraft) && 
                                <MvcInvoiceList
                                    control={control}
                                    name={"invoices"}
                                    allowAdd={!isView}
                                    allowDelete={!isView}
                                    Mvc={mvc} /> 
                            }

                            {isEdit && !isEditDraft && 
                                <MvcInvoiceItemsList
                                    control={control}
                                    name={"invoiceItems"}
                                    allowDelete={!isView}
                                    Mvc={mvc}
                                    allowAdd={!isView} 
                                    title={tMvc("invoices")}
                                    isRack={true}/>
                            }

                            {isViewDraft &&
                                <>
                                    <MvcInvoiceList
                                        title={tMvc("materialSalesInvoices")}
                                        control={control}
                                        name={"invoices_Sales"}
                                        allowAdd={!isView}
                                        allowDelete={!isView}
                                        Mvc={mvc} /> 

                                    <MvcInvoiceList
                                        title={tMvc("rackInvoices")}
                                        control={control}
                                        name={"invoices_Rack"}
                                        allowAdd={!isView}
                                        allowDelete={!isView}
                                        Mvc={mvc} />

                                    <MvcInvoiceList
                                        title={tMvc("otherInvoices")}
                                        control={control}
                                        name={"invoices_Others"}
                                        allowAdd={!isView}
                                        allowDelete={!isView}
                                        Mvc={mvc} />
                                </>
                            }

                            { isView && !isViewDraft && 
                                <>
                                    <MvcInvoiceItemsList
                                        control={control}
                                        name={"invoiceItems_Sales"}
                                        allowDelete={!isView}
                                        Mvc={mvc}
                                        allowAdd={!isView} 
                                        title={tMvc("materialSalesInvoices")}
                                        isRack={false}/>

                                    <MvcInvoiceItemsList
                                        control={control}
                                        name={"invoiceItems_Rack"}
                                        allowDelete={!isView}
                                        Mvc={mvc}
                                        allowAdd={!isView} 
                                        title={tMvc("rackInvoices")}
                                        isRack={true}/>
                                    
                                    <MvcInvoiceItemsList
                                        control={control}
                                        name={"invoiceItems_Others"}
                                        allowDelete={!isView}
                                        Mvc={mvc}
                                        allowAdd={!isView} 
                                        title={tMvc("otherInvoices")}
                                        isRack={false}/>
                                </>
                            }

                            {!isInsert && <MvcLogList 
                                control={control}
                                name={"mvcLogs"} />}
                                    
                            <Grid container spacing={1}>
                                <Grid item xs={12} style={{ padding: "0px", textAlign: 'left', marginTop: "30px", marginLeft:"5px" }}>
                                    
                                    <ButtonUI
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => history.replace(isViewPA ? '/PendingAccounting' :'/Mvc')}
                                        startIcon={<ArrowBack />}>
                                        {tGeneral("back")}
                                    </ButtonUI>
                                    { isInsert && 
                                        <ButtonUI onClick={() => save(false) } color="primary" startIcon={<AddIcon />}>{tGeneral("add")}</ButtonUI>
                                    }
                                    { isEdit &&
                                            <ButtonUI onClick={() => save(false) } color="primary" startIcon={<SaveIcon />}>{tGeneral("save")}</ButtonUI>
                                    }
                                    { (isInsert || isEditDraft) &&
                                        <ButtonUI onClick={() => save(true) } color="primary">{tMvc("submit")}</ButtonUI>
                                    }
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </div>
            </Container>
        )
}
export default SubmitMvc;
